import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle } from 'lucide-react';
import { equipmentData } from '../mockData';

export const EquipmentPage = () => {
  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Nossos Equipamentos
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore nossa linha completa de equipamentos de diagnóstico por imagem
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {equipmentData.map((equipment) => (
            <Card key={equipment.id} className="hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="h-64 overflow-hidden bg-gray-100">
                <img 
                  src={equipment.image} 
                  alt={equipment.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="space-y-2">
                    <CardTitle className="text-2xl">{equipment.name}</CardTitle>
                    <p className="text-sm text-blue-600 font-medium">{equipment.category}</p>
                  </div>
                  <div className="h-12 w-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="text-blue-600" size={24} />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-gray-600">{equipment.description}</p>
                <div className="space-y-2">
                  <p className="font-semibold text-gray-900">Características Principais:</p>
                  <ul className="space-y-2">
                    {equipment.features.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-2">
                        <CheckCircle className="text-green-600 flex-shrink-0 mt-0.5" size={18} />
                        <span className="text-gray-600">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="pt-4">
                  <Link to="/contact">
                    <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                      Solicitar Informações
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 text-center">
          <Card className="bg-blue-50 border-blue-200">
            <CardContent className="p-8 space-y-4">
              <h3 className="text-2xl font-bold text-gray-900">
                Precisa de Ajuda para Escolher o Equipamento Certo?
              </h3>
              <p className="text-gray-600">
                Nossos especialistas estão aqui para ajudá-lo a encontrar a solução perfeita para sua necessidade
              </p>
              <Link to="/contact">
                <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-white">
                  Entre em Contato com Nossa Equipe
                </Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};